import { Type } from '@angular/core'

import { Hero } from 'app/core/cms/type-unions'

import { CmsBlock } from '../cms-block'
import { HeroOverlayComponent } from './hero-overlay/hero-overlay.component'
import { HeroSplitComponent } from './hero-split/hero-split.component'

type HeroMapping = {
  [key in Hero['__typename']]: Type<CmsBlock<Hero & { __typename: key }>>
}

export const HERO_MAPPING = {
  HeroSplit: HeroSplitComponent,
  HeroOverlay: HeroOverlayComponent,
} as const satisfies HeroMapping
